import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import LogoutIcon from '@mui/icons-material/Logout';
import { Box, Grid, IconButton, ListItemButton, ListItemIcon, ListItemText, Paper, Typography, useMediaQuery } from '@mui/material';
import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import Image from '../../Assets/assetHelper';
import { AuthContext } from '../../Helpers/Contexts/authContext';
import KenColors from '../../Helpers/Themes/kenColors';
import { ReactChildren } from '../../interfaces/Common';
import { AuthUser } from '../../interfaces/Contexts';
import AppBreadCrumbs from '../BreadCrumbs';
import SideNavTabs from './Tabs';
import { useStyles } from './styles';

const AppLayout: React.FunctionComponent<ReactChildren> = ({ children }) => {
  const classes = useStyles();
  const { dispatch } = useContext(AuthContext);
  const navigate = useNavigate();
  const isMobile = useMediaQuery('(max-width:1025px)');

  const userData = JSON.parse(`${localStorage.getItem('user')}`) as AuthUser;
  const handleListClick = (path: string, index: number) => {
    navigate(path);
  };

  return (
    <Grid container spacing={3} style={{ padding: isMobile ? '4px 4px' : '20px 20px 20px 20px' }} sx={{ width: '100vw', height: '100vh' }}>
      <Grid item xs={2} md={2}>
        <Paper className={classes.nav}>
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: isMobile ? 'center' : '' }}>
            <div style={{ marginBottom: '24px' }}>
              <img
                className={classes.profilImage}
                src={userData?.applicationProfile ? userData.applicationProfile : Image.Images.DefaultProfileImage}
                alt="profile"
                style={{ width: isMobile ? '40px' : '90px', height: isMobile ? '40px' : '90px' }}
              />
              <Typography className={classes.profileName}>{userData?.applicantName ? (isMobile ? userData.applicantName.slice(0, 2).toUpperCase() : userData.applicantName) : ''}</Typography>
              {userData?.graduationYear !== 'null' && <Typography className={classes.profileDesignation}>Class of {userData?.graduationYear ? userData?.graduationYear : '-'}</Typography>}
            </div>
            <SideNavTabs handleListClick={handleListClick} />
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: isMobile ? 'center' : '' }}>
            <ListItemButton
              className={classes.listItemButton}
              onClick={() => {
                dispatch({ type: 'LOGOUT' });
              }}
            >
              <ListItemIcon sx={{ minWidth: { xs: '2px', lg: '40px' } }}>
                <LogoutIcon className={classes.listItemIcon} />
              </ListItemIcon>
              <ListItemText
                className={classes.listItemText}
                sx={{
                  display: { xs: 'none', sm: 'none', md: 'none', lg: 'block' },
                }}
              >
                Logout
              </ListItemText>
            </ListItemButton>
          </div>
        </Paper>
      </Grid>
      <Grid item xs={10} md={10}>
        <Grid container spacing={3} lg={12}>
          <Grid item container spacing={3} xs={12} lg={12}>
            <Grid item xs={6} sm={8} md={7} lg={9}>
              <Paper className={classes.header} sx={{ borderRadius: '16px !important' }}>
                <AppBreadCrumbs />
              </Paper>
            </Grid>
            <Grid item xs={6} sm={4} md={5} lg={3}>
              <Paper className={classes.actions}>
                {/* <IconButton sx={{ marginRight: { xs: '1px', lg: '10px' } }}>
                  <AccountCircleIcon sx={{ fontSize: { xs: '30px', lg: '36px' } }} />
                </IconButton> */}
                <IconButton sx={{ marginRight: { xs: '1px', lg: '10px' } }}>
                  <AccountCircleIcon sx={{ fontSize: { xs: '30px', lg: '36px' } }} />
                </IconButton>
                <div style={{ width: '1px', height: '60px', background: KenColors.ClientBlue8 }} />
                <img alt="logo" className={classes.actionLogo} src={Image.Images.DefaultOrganizationLogo} />
                <div style={{ textAlign: 'start' }}>
                  <Typography className={classes.actionText}>AIMS</Typography>
                  <Typography className={classes.actionText}>Institute</Typography>
                </div>
              </Paper>
            </Grid>
          </Grid>
          <Box
            sx={{
              overflow: 'auto',
              height: `calc(100vh - 15vh)`,
              width: `calc(100vw - 30px)`,
              scrollbarColor: 'white',
              paddingTop: '10px',
              paddingLeft: '22px',
              scrollbarWidth: 'none',
            }}
          >
            {children}
          </Box>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default AppLayout;
